// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu {
    background-color: #eee;
    padding: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/panels/menu.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,YAAY;AAChB","sourcesContent":[".menu {\n    background-color: #eee;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
